import type { Cart } from '../../../../codegen/types';
import type { ExtendedLineItem } from '../../../../types/product';
import { getAmount } from '../../../currencyHelper';
import { createLineItem } from '../../utils/createLineItem';
import { sendDataLayerEvent } from '../../utils/dataLayerInteractions';
import EventNamesType from '../eventNamesType';

export function sendAddToCartFromQuickBuyEvent(addedProductSku: string, cart: Cart, baseUrl: string) {
  if (addedProductSku && cart) {
    const { lineItems } = cart;
    const addedCartProduct = lineItems.find((product) => product?.variant?.sku === addedProductSku);
    const value = addedCartProduct?.price.value;

    if (!addedCartProduct) return;

    // update added product quantity to 1, PLP can add only single product
    const addedProduct: ExtendedLineItem = {
      ...addedCartProduct,
      index: 0,
      quantity: 1,
      images: addedCartProduct.imageURLs,
      baseUrl,
    };

    const cartItems = {
      items: lineItems?.map((item) => createLineItem(item)),
    };

    sendDataLayerEvent(
      EventNamesType.add_to_cart,
      {
        ecommerce: {
          currency: value?.currencyCode,
          value: +getAmount(value?.centAmount),
          items: [createLineItem(addedProduct)],
        },
        cart: {
          currency: cart.currency,
          value: +getAmount(cart.total),
          cartItems,
        },
      },
      true,
      { cartId: cart.id },
    );
  }
}
